import React from 'react'
import { logout } from '../api'
import { useNavigate } from 'react-router-dom'
import { Anchor, Button, Group } from '@mantine/core'
import { KnowledgeSearch } from '../components/KnowledgeSearch'
import { BaseHeader, headerButtonProps } from '../components/BaseHeader'

const HeaderContainer = () => {
  const navigate = useNavigate()

  const handleClickLogout = async () => {
    await logout()
    navigate('/admin/login')
  }

  return (
    <BaseHeader>
      <Group display="flex" gap={32}>
        <Group display="flex" gap={32}>
          <Anchor
            href="https://www.creativehope.co.jp/invyknowledge"
            target="_blank"
            rel="noopener noreferrer"
            fz={12}
            c="#000000CC"
          >
            invyご利用ガイド
          </Anchor>
          <Anchor
            href="https://s.creativehope.co.jp/invy/blog"
            target="_blank"
            rel="noopener noreferrer"
            fz={12}
            c="#000000CC"
          >
            リファラル研究所
          </Anchor>
          <Anchor
            href="https://invy.jp/invy/invite"
            target="_blank"
            rel="noopener noreferrer"
            fz={12}
            c="#000000CC"
          >
            invyを紹介しよう
          </Anchor>
        </Group>
        <KnowledgeSearch />
        <Button {...headerButtonProps} onClick={handleClickLogout}>
          ログアウト
        </Button>
      </Group>
    </BaseHeader>
  )
}

export default HeaderContainer
